var path = '/app/pages/account/codes/account.codes.html';
var html = "";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/account/codes/account.codes.html
// module id = 1107
// module chunks = 0